/* eslint-disable max-classes-per-file */

// Known error that should not be reported to bugsnag.
export class BugsnagIgnoredError extends Error {
  name = 'BugsnagIgnoredError';
}

export class UrlParamMissingError extends Error {
  name = 'UrlParamMissingError';

  param: string;

  constructor(param: string) {
    super(`param ${param} is missing`);
    this.param = param;
  }
}
